module.exports = __webpack_public_path__ + "img/底部bg.338c321b.png";